import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { formatCurrency } from 'ggx-service/i18n/format-currency.service'
import { Body, SmallText } from 'ggx-componentlibrary/design/typography/typography.styles'
import { useTranslation } from 'react-i18next'

const ENABLE = true
export default {
  withTruckLabel(t, vehicle, index, settings, origin) {
    if (ENABLE && vehicle !== 'van') {
      return t('d2d_times__truck', {
        count: index + 1,
        fee: formatCurrency({
          amount: (index + 1) * settings.price_per_cart
        })
      })
    } else {
      return origin
    }
  },
  withTruckDescription(t, vehicle, origin) {
    if (ENABLE && vehicle !== 'van') {
      return <>
        <Body typographyStyles="mb-none">
          {t('text__number_of_pallets')}
        </Body>
        <SmallText typographyStyles="">
          {t('text__number_of_pallets_body')}
        </SmallText>
      </>
    } else {
      return origin
    }
  },
  useWithTruckTitle(formSelector) {
    const [t] = useTranslation()
    const vehicle = useSelector(state => formSelector(state, 'vehicle'))
    return useCallback((title, origin) => {
      return ENABLE && vehicle !== 'van' ?
        t('d2d_fixed_trunk_fee__price_breakdown', { count: Number(title.substr(22)) }):
        origin
    }, [t, vehicle])
  },
  withTruckTitle(t, vehicle, title, origin) {
    return ENABLE && vehicle !== 'van' ?
      t('d2d_fixed_trunk_fee__price_breakdown', { count: Number(title.substr(22)) }) :
      origin
  },
}
